/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Cat_MediaInputs */

const cs_builder_cat_media = /** @type {(inputs: Builder_Cat_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Média`)
};

const en_builder_cat_media = /** @type {(inputs: Builder_Cat_MediaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Media`)
};

/**
* | output |
* | --- |
* | "Media" |
*
* @param {Builder_Cat_MediaInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_cat_media = /** @type {((inputs?: Builder_Cat_MediaInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Cat_MediaInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_cat_media(inputs)
	return cs_builder_cat_media(inputs)
});